import { basicEntityFromJson, IBasicEntity } from "../../../core/models";
import { parseNumber, toPrecision } from "../../../core/utils";
import { clientFromJson, IClient } from "../../client/data/entities";
import { ITransaction, transactionFromJson } from "../../transaction/data/entities";

interface IClientHistoryBase {
  balanceBefore: number;
  balanceAfter: number;
  transaction: ITransaction;
  client: IClient;
}

export interface IClientHistory extends IClientHistoryBase, IBasicEntity {}

export const clientHistoryFromJson = (json: any): IClientHistory => {
  const e: IClientHistory = {
    ...basicEntityFromJson(json),
    balanceBefore: parseFloat(json.balanceBefore),
    balanceAfter: toPrecision(parseNumber(json.balanceAfter)),
    transaction: transactionFromJson(json.transaction),
    client: clientFromJson(json.client),
  };

  return e;
};

export const clientHistoryToJson = () => {
  return {};
};
